import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core'

import { TaskCompletionStatusComponent } from '../..'
import { Resource, UserTask, Task } from '@mprep/shared/data/models'
import { ResourceService, UserTaskService } from '@mprep/shared/data/services'

@Component({
  selector: 'mp-subtask',
  templateUrl: './subtask.html',
  styleUrls: ['./subtask.scss', './subtask.inverted-theme.scss']
})

export class SubtaskComponent implements OnInit {
  public resource: Resource
  public userTask: UserTask

  @Input()
  public task: Task

  @Input()
  public theme: string

  @Output()
  public containerClass: string

  @Output()
  public completionStatusChanged = new EventEmitter<string>()

  @ViewChild('completionStatus')
  public completionStatusComponent: TaskCompletionStatusComponent

  constructor(
    private _resourceService: ResourceService,
    private _userTaskService: UserTaskService
  ) {}

  public ngOnInit() {
    this.theme = typeof this.theme === 'string' && this.theme.endsWith('-theme') ? `${this.theme}` : ''
    this.containerClass = this.task.title.length > 5 ? 'col-xs-12 col-sm-6 col-md-4' : 'col-xs-12 col-sm-4 col-md-3'
    this._resourceService.getResource(this.task.resourceId).subscribe((resource: Resource) => {
      this.resource = resource
    })

    this._userTaskService.findByTask(this.task).subscribe((userTasks: UserTask[]) => {
      let userTask = userTasks[0]
      this.userTask = userTask ?
          userTask :
          this._userTaskService.buildUserTask(this.task)
      })
  }

  public sendCompletionStatusToParent(newStatus: string) {
    this.completionStatusChanged.emit(newStatus)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/subtask/subtask.component.ts